<template>
    <div
            class="modal fade"
            id="sys_apply_common_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">
                        {{instance.define_name}}(当前节点 {{instance.node}}) No. {{instance.id}}
                    </h4>
                </div>

                <!-- modal-body-->
                <div class="modal-body">
                    <div class="form-horizontal">

                        <div class="form-group">
                            <label class="col-sm-2 control-label">申请时间:</label>
                            <div class="col-sm-4">
                                {{instance.create_at}}
                            </div>
                            <label class="col-sm-2 control-label">申请人:</label>
                            <div class="col-sm-4">
                                {{instance.initiator_name}}
                            </div>
                        </div>

                        <div class="form-group form-fields-panel">
                            <div class="col-sm-6" v-for="(item,index) in context" :key="index">
                                <label class="col-sm-4 control-label">{{index}}:</label>
                                <div class="col-sm-8">
                                    {{item}}
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-primary" @click="judgeApprove">通过</button>
                    <button type="button" data-dismiss="modal" class="btn btn-danger" @click="judgeReject">拒绝</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        instance: {}, // 实例
        context: {} // 上下文
      }
    },

    props: [],

    mounted: function () {
      var self = this
    },

    methods: {
      initFunc: function (instance) {
        var self = this
        console.log('___initFunc 传入 instance', instance)
        $('#sys_apply_common_modal').modal('show') // 展示 modal 框
        self.instance = instance
        self.context = JSON.parse(instance.context)
        console.log('___self.context', self.context)
      },
      judgeApprove: function () { // 审批通过
        this.submitJudge('approve')
      },
      judgeReject: function () { // 审批拒绝
        this.submitJudge('reject')
      },
      // 提交
      submitJudge: function (judge) {
        console.log('___judge', judge)
        var self = this
        var putData = {
          'judge': judge
        }
        self.global.axiosPut(
          self,
          `instance/${self.instance.id}/judge/`,
          putData,
          function (res) {
            console.log('审批返回结果', res)
            if (res.status === 'success') {
              alert('提交成功')
              $('#approval_list_table').bootstrapTable('refresh')
            } else
              alert('提交失败')
          },
          function () {
            alert('提交失败')
          }
        )
      }
    }
  }
</script>
<style scoped>

    .form-fields-panel {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }
</style>



// WEBPACK FOOTER //
// src/views/approvalCenter/instanceApplyCommon.vue